import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { driverCellContent } from "./driverCellContent";
import { useDriverNamesContext } from "./DriverNamesContext";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";
import { getErrorMessage } from "@/utilities/error/getErrorMessage";

export function DriverCell({ row }: GridRenderCellParams<DeviceStatusOverviewData>) {
  const { t } = useTranslation();
  const lookup = useDriverNamesContext();
  const content = driverCellContent(row.driverId, lookup);

  switch (content.kind) {
    case "empty":
      return <></>;
    case "loading":
      return <Skeleton width="100%" variant="text" />;
    case "name":
      return <>{content.name}</>;
    case "unknown":
      return (
        <Tooltip
          title={
            content.reason === "lookupFailed"
              ? `${t("faultOverview.driverLookupFailed")} ${getErrorMessage(lookup.error)}`
              : t("faultOverview.driverNotFound")
          }
        >
          <Box component="span" sx={{ color: "text.secondary" }}>
            {t("faultOverview.driverUnknown")}
          </Box>
        </Tooltip>
      );
  }
}
